
import Spinner from "../includes/Spinner.vue";

export default {
  name: "FileEntry",
  components: { Spinner },
  props: {
    filename: {
      type: String,
      required: true,
    },
    id: {
      type: String,
      required: true,
    },
    complete: {
      type: Boolean,
      default: false,
    },
    downloading: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    icon() {
      return this.complete && !this.downloading ? "mc-folder" : "";
    },
  },
  methods: {
    onClick() {
      if (this.complete && !this.downloading)
        this.$emit("entry-clicked", { filename: this.filename, id: this.id });
    },
  },
};
